export type CompressedIndex = {
    start: number;
    count: number;
};

export class IndexUtils {
    public static compressAndRebuildIndex(indexes: number[]): CompressedIndex[] {
        return IndexUtils.rebuildIndex(IndexUtils.compressIndex(indexes));
    }

    public static compressIndex(indexes: number[]): CompressedIndex[] {
        const res = new Array<CompressedIndex>();
        let prev: CompressedIndex = { start: Number.MIN_VALUE, count: Number.MIN_VALUE };
        for (const index of indexes) {
            if (prev.start + prev.count === index) {
                prev.count++;
            } else {
                res.push((prev = { start: index, count: 1 }));
            }
        }
        return res;
    }

    public static rebuildIndex(indexes: CompressedIndex[]): CompressedIndex[] {
        let shift = 0;
        for (const index of indexes) {
            index.start -= shift;
            shift += index.count;
        }
        return indexes;
    }
}
